module.exports = __webpack_public_path__ + "static/img/food-img-3.ab8fd16.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/food-img-3.png
// module id = Xkra
// module chunks = 1